const findSectorValue = (subsector, sectorData) => {
  if (!sectorData || !subsector) return null;

  const foundItem = sectorData
    .flatMap((group) => group.groupItems || [])
    .find((item) => item.label.toLowerCase() === subsector.toLowerCase());

  return foundItem ? foundItem.value : null;
};

const filterAISuggestions = (suggestions, sectorData) => {
  if (!Array.isArray(suggestions) || !sectorData) {
    return suggestions;
  }

  return suggestions.filter((suggestion) => {
    if (!suggestion || !suggestion.subsector) return false;

    return findSectorValue(suggestion.subsector, sectorData) !== null;
  });
};

const groupSuggestionsBySector = (suggestions) => {
  if (!Array.isArray(suggestions)) {
    return {};
  }

  return suggestions.reduce((groups, suggestion) => {
    const sectorName = suggestion.sector || 'Other';
    return {
      ...groups,
      [sectorName]: [...(groups[sectorName] || []), suggestion],
    };
  }, {});
};

export { findSectorValue, filterAISuggestions, groupSuggestionsBySector };
